import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    success: translate({ id: 'giveFeedback.toast.success' }),
    error: translate({ id: 'giveFeedback.toast.error' }),
  }))

  return api
}
